import AcInput from 'ac-components/ac-ipt';
import React, { FC, ChangeEvent, memo, useRef, useEffect, useState } from 'react';
import { history } from '@store/history';
import classnames from 'classnames';
import generatePath from '@utils/generatePath';
import styles from './styles.scss';
import { AGREEMENT_POLICY, AGREEMENT_USER, RESERVATION_PAGE} from 'constants/url';
import AreaSelect, { Area } from 'containers/ac-containers/area-select';
import { toast } from 'components/dialogs';
import { fetchRegistration } from '@services/landing';

/**
 * 接口请求传输
 *
 * @interface IFormDataParams
 */
 interface IFormDataParams {
	firstName: string;
	lastName: string;
	areaCode: string | number;
	phone: string;
	email: string;
	message: string;
	disabled: boolean;
}
const FreeForm: FC = () => {
	const [offsetWidth, setWidth] = useState<string | number>(0);
	const [area, setArea] = useState<Area>();
	const [areaTip, setAreaTip] = useState<string>('');
	const [alertTip, setAlertTip] = useState<string>('');
	const [phone, setPhone] = useState<string>('');
	const [phoneTip, setPhoneTip] = useState<string>('');
	const cardRef = useRef<HTMLDivElement | null>(null);
	const emailRules = /^\w+([.-]\w+)*@\w+([.-]\w+)*\.\w+$/;
	const initFormParams: IFormDataParams = {
		firstName: '',
		lastName: '',
		areaCode: '',
		phone: '',
		email: '',
		message: '',
		disabled: false
	};
	const [selectText, setSelectText] = useState(''); // 点击选中某项文案
	const checkRef = useRef<HTMLInputElement>(null);
	const checkRef1 = useRef<HTMLInputElement>(null);
	const [formParams, setFormParams] = useState(initFormParams);
	const [formData, setFormData] = useState(initFormParams);
	function handleInputChange(key: string, val: string) {
		setFormParams({
			...formParams,
			[key]: val,
		});
	}
	// 选择国家地区
	const onAreaChange = (item: Area) => {
		setArea(item);
		setFormParams({
			...formParams,
			areaCode: item.code,
		});
		setAreaTip('');
	};
	// 输入号码
	const onPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		handleInputChange('phone', e.target.value);
		setPhoneTip('');
		setAlertTip('');
	};
	async function handleSubmit() {
		if (!formParams.firstName || !formParams.lastName) {
			toast({ message: 'Errors in first name/last name!'});
			return;
		}
		if (!formParams.email && !emailRules.test(formParams.email)) {
			toast({
				message: 'Please check the email!',
			});
			return;
		}
		if (!formParams.phone) {
			toast({
				message: 'Please fill in the phone number!',
			});
			return;
		}
		if (!checkRef1.current?.checked) {
			toast({
				message: 'You need to agree to all our terms before sign up!',
			});
			return;
		}
		if (!checkRef.current?.checked) {
			toast({
				message: 'Please read and consent to the User Agreement and Privacy Policy!',
			});
			return;
		}
		formParams.disabled = true;
		fetchRegistration(
			{
				name: formParams.firstName + formParams.lastName,
				mobile: formParams.phone,
				email: formParams.email,
				areaCode: formParams.areaCode,
				regTypeEnum: "REG_AC_KIDS",
				comeFrom: "UK_Landing",
				mark: formParams.message || "",
				languages:["en"]
			}).then((res) => {
				
			}).catch((err) => {
				if (err.data.regId) {
					const regId = err.data.regId;
					console.log(regId, 'regId');
					history.push({
						pathname: generatePath(RESERVATION_PAGE),
						search: `?regId=${regId}&name=${formParams.firstName + formParams.lastName}&mark={formParams.message}`,
					});
				}
				toast({
					message: err.message || 'System error. Try again',
				});
		});
	}
	useEffect(() => {
		if (cardRef.current) {
			setWidth(cardRef.current.offsetWidth);
		}
	}, [cardRef.current]);
	return (
		<div className={styles['booking-container']} >
			<h1>Almost done! </h1>
			<p className={styles['text']}>We just need your details to schedule a free trial lesson with the most suitable tutor.</p>
			<div className={styles['steps']}>
				<div className={styles['step1']}></div>
			</div>
			<div className={styles['item-box']}>
				<div className={styles['left']}>
					<input className={styles['input']} placeholder="First Name*" value={formParams.firstName} 
					onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputChange('firstName', e.target.value)} />
				</div>
				<div className={styles['right']}>
					<input className={styles['input']} placeholder="Last Name*" value={formParams.lastName} 
					onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputChange('lastName', e.target.value)} />
				</div>
			</div>
			<div className={styles['item-box']} ref={cardRef}>
				{(areaTip || phoneTip) && <div className={styles.verify_tip}>{areaTip || phoneTip}</div>}
				<AcInput className={styles.phoneNumber} placeholder="Phone Number" type="number" value={phone}
				onChange={onPhoneChange} prefix={<AreaSelect selected={area} onChange={onAreaChange} width={offsetWidth} />} />
			</div>
			<div className={styles['item-box']}>
				<input className={styles['email']} placeholder="Email Address*" value={formParams.email} 
				onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputChange('email', e.target.value)} />
			</div>  
			{/* <div className={styles.textarea}> */}
				<textarea className={styles['textarea']} placeholder="Your Message (optional)"
				onInput={(event) => {
					formParams.message = (event.target as HTMLInputElement).value;
				}} />
			{/* </div> */}
			<div className={styles['item-box']}>
				<div className={styles['agreement-box']}>
					<input className={classnames(styles['check-box'], styles['check-box1'])} type="checkbox"
						ref={checkRef1} value="#f0544d" id="check-box1"/>
					<label htmlFor="check-box1"></label>
					<p>Consent to receive your promotion emails and SMS</p>
				</div>
				<div className={styles['agreement-box']}>
					<input className={classnames(styles['check-box'], styles['check-box1'])} type="checkbox"
						ref={checkRef} value="#f0544d" id="check-box"/>
					<label htmlFor="check-box"></label>
					<p>Consent to <a href={AGREEMENT_USER} target="_blank">User Agreement</a> and <a href={AGREEMENT_POLICY} target="_blank">Privacy Policy</a>.</p>
				</div>
			</div>
			<button className={styles['booking-button']} disabled={formParams.disabled} onClick={handleSubmit}>BOOK YOUR FREE TRIAL</button>
			<p className={styles['attention']}>ATTENTION: There are a limited number of daily places.</p>
		</div>
	);
}
export default memo(FreeForm);
